var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYakBannerLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 352.08 135.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-2 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3 {\n        fill: #ededed;\n        font-family: Bellefair-Regular, Bellefair;\n        font-size: 49.02px;\n      }\n\n      .cls-4 {\n        letter-spacing: .03em;\n      }\n\n      .cls-5 {\n        fill: #dadada;\n        font-family: OpenSans, 'Open Sans';\n        font-size: 30.25px;\n        letter-spacing: .02em;\n      }\n\n      .cls-6 {\n        fill: #c6c6c6;\n        stroke-width: 0px;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m0,2.75l42.7,70.7S66.19,12.83,128.42.06c0,0-51.42-3.6-85.48,45.52L0,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m143.77,3.74l-70.7,42.7s60.62,23.5,73.39,85.72c0,0,3.6-51.42-45.52-85.48L143.77,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m14.05,132.47L56.75,61.77s23.5,60.62,85.72,73.39c0,0-51.42,3.6-85.48-45.52l-42.94,42.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(176.55 103) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LAW OFFICE")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(176.84 65.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 25.98,
    y: 0
  }, ".A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 75.19,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 87.99,
    y: 0
  }, "K IP")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYakBannerLight);
export default __webpack_public_path__ + "static/media/yak-banner-light.d145e45367ebd63683f7a5edeabf547e.svg";
export { ForwardRef as ReactComponent };